import { render } from "./Cube.vue?vue&type=template&id=4d392cea"
import script from "./Cube.vue?vue&type=script&lang=js"
export * from "./Cube.vue?vue&type=script&lang=js"

import "./Cube.vue?vue&type=style&index=0&id=4d392cea&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__